#import "./HaftarahDetails.graphql"
query HaftarotQuery($parashah: ID!, $mine: Boolean!) {
  haftarot(parashah: $parashah, mine: $mine) {
    ...haftarahDetails
  }
}
